export const PIXEL_ID = '1488546406038436'

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbq: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _fbq: any
  }
}

export function initPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  // Initialize the fbq stub before the script loads
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  window.fbq = n
  window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Inject the fbevents.js script — append to <head> to avoid missing parentNode
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (typeof window === 'undefined') return
  if (!window.fbq) initPixel()
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (typeof window === 'undefined') return
  if (!window.fbq) initPixel()
  window.fbq('track', 'AddToCart', {
    value: 59.0,
    currency: 'USD',
    content_name: 'Chatbot Agenda Total',
    content_type: 'product',
    content_ids: ['52033881440548'],
  })
}
